/**
 * Shared Best Drive business contact configuration.
 *
 * Single source of truth for the business telephone number so the same value
 * is not duplicated across marketing pages, portal pages and schema data.
 *
 * NOTE: the values below intentionally match the previously hard-coded
 * strings exactly — display text, tel: links, sms: links and structured data
 * must render identically to before.
 */

/** Raw national-format digits, used for sms: links. */
export const PHONE_RAW = '07564936033';

/** Human-readable display format, e.g. shown in body copy. */
export const PHONE_DISPLAY = '07564 936033';

/** International display format. */
export const PHONE_DISPLAY_INTL = '+44 7564 936033';

/** E.164 number used in JSON-LD / structured data. */
export const PHONE_E164 = '+447564936033';

/** Ready-to-use tel: href. */
export const PHONE_TEL = `tel:${PHONE_E164}`;

/** Bare sms: href (no message body). */
export const PHONE_SMS = `sms:${PHONE_RAW}`;

/** Builds an sms: link with a pre-filled message body. */
export const smsLink = (message: string) =>
  `${PHONE_SMS}?&body=${encodeURIComponent(message)}`;

/** WhatsApp deep link. */
export const WHATSAPP_HREF = `https://wa.me/44${PHONE_RAW.replace(/^0/, '')}`;
